import * as z from 'zod'
import { ClientPortalUsersActivityReportPayload } from '~bank-reports/types/ClientPortalUsersActivityReport'

export const clientPortalUsersActivityReportPayloadSchema = z.object({
  status: z.string().optional().nullable(),
  sortBy: z.string().optional().nullable(),
  sortDesc: z.boolean().optional().nullable(),
  relationshipId: z.number().optional().nullable(),
  page: z.number().int().positive().default(1),
  size: z.number().int().positive().default(10)
}) as z.ZodType<Omit<ClientPortalUsersActivityReportPayload, 'id'>>
